<template>
  <v-container>
    
      <v-row>
         

          <v-col :lg="6" class="p-4">
            <v-img
    
    src="/img/top2.jpg"
    
  ></v-img>
   
              <!--<v-alert
      border="left"
      color="primary"
      dark
    >
Tu moze byt nejaky text
    </v-alert>-->
               <v-card class="mt-4">
                    
                   
                    <v-card-title class="primary white--text" dark flat>
              <span class="headline">1. Vyberte si model vozidla</span>
            </v-card-title>

      <!--<v-select  prepend-icon="build"
                 item-text="name"
                                item-value="id"
                                :items="branches"
                                v-model="branch"
                                label="Prevádzka*"
                                @change="initCalendarMonth"
                                class="pa-3"

                                >

                            </v-select>-->
                             <v-row class="py-4" dense>
                               <v-col
                                v-for="car in getCheckType"
                                :key="car.id"
                                
                                @click="setCheckType(car.id)"
                               >
 <v-card
    class="mx-auto"
    max-width="250"
    :hover="true"
    z-depth="0"
     elevation="2"
  >
    <v-img
      class="white--text align-end"
      height="200px"
      :src='"/img/"+car.id+".png"'
      contain
    >
   
      <v-card-title class="black--text pt--6">{{car.name}}  
        
              <v-btn v-if="check_type && check_type===car.id" class="ml-4" color="primary" dark fab small>

        <v-icon  color="white" class="">mdi-check-bold</v-icon>
          </v-btn>
          </v-card-title>
    </v-img>
    
  </v-card>
  </v-col>
               
</v-row>

                    <!--<v-select item-text="name"
                                item-value="id"
                                label="Druh kontroly*"
                                prepend-icon="visibility"
                                :items="getCheckType"
                                v-model="check_type"
                                :error="($v.check_type.$error===true)?true:false"
                                @change="setCheckType"
class="pa-3"
                                >

                            </v-select>-->
                   <div v-if="showNotAvailable" class="ma-3">
                      <v-alert type="error">
    </v-alert>
             <v-spacer></v-spacer>
             <br/>
                   </div>
               </v-card>
<div class="dateselect">
              <v-card class="mt-5" v-if="branch && check_type && !showNotAvailable">
                    <v-card-title class="primary white--text" dark flat>
              <span class="headline">2. Zvoľte si Vami preferovaný dátum s Audi</span>
            </v-card-title>

    <v-sheet height="150">
        <!--<v-toolbar flat color="white">
          <v-btn outlined class="mr-4" @click="setToday">
            Dnes
          </v-btn>
          <v-btn fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>

        </v-toolbar>-->
    <v-calendar
        ref="calendar"
      type="custom-weekly"
     v-model="focus"
      @click:more="setDay"
          @click:date="setDay"
          @change="updateRange"
           locale="sk"
           first-interval=5
          :interval-format="intervalFormat"
          :weekdays="[1,2]"
          start="2021-09-13"
          end="2021-09-14"
    >
        <template v-slot:day="{ present, past, date, day,weekday,canBeSet }">
            <v-row
              class="fill-height"
            >
              <template>
                <v-sheet

                  color="primary"
                  width="100%"
                  height="100%"
                  tile
                  @click="setDay(date)"
                  v-if="!past && isReservable(date)"
                ></v-sheet>
              </template>
            </v-row>
          </template>
        <template v-slot:day-label="{ present, past, date, day,weekday,canBeSet }">
            <v-row
              class="fill-height"
            >
              <template>
                <v-sheet

                  color="primary"
                  width="100%"
                  height="100%"
                  tile
                  v-if="!past && isReservable(date)"
                  @click="setDay(date)"
                >
                    <div class="mt-8 primary white--text bold" color="white" @click="setDay(date)" v-if="!past">{{niceDateFormat(date)}}</div>
                </v-sheet>
                  <v-sheet

                  width="100%"
                  height="100%"
                  tile
                  v-else
                >
                    <div class="mt-8 text-white" color="white">{{niceDateFormat(date)}} (obsadené)</div>
                </v-sheet>
              </template>
            </v-row>
          </template>
      </v-calendar>
        </v-sheet>
          </v-card>
         </div>
          </v-col>
           
      </v-row>
          <v-row class="timeselect">
       <v-col :lg="6" class="p-4">
               <v-card class="mt-50" v-if="branch && selectedDay && !showNotAvailable">
                    <v-card-title class="primary white--text" dark flat>
              <span class="headline">3. Vyberte si čas</span>
            </v-card-title>


       <v-sheet class="px-4">

      
     <!--<v-toolbar flat color="white">
          <v-btn outlined class="mr-4" @click="setToday">
            Dnes
          </v-btn>
          <v-btn fab text small @click="prevWeek">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small @click="nextWeek">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title class="pl-6">{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>

        </v-toolbar>
-->

     <v-row class="py-4" dense>
                               <v-col
                                v-for="hour in [9,12,15]"
                              
                                
                                v-if="isReservableHour(selectedDay,hour)"
                                @click="setHour(selectedDay,hour)"
                                :lg="3"
                               >
 <v-card
    class="mx-auto text-center"
    max-width="500"
    min-height="80px"
    :hover="true"
    z-depth="0"
     elevation="2"
  >
   
   
      <v-card-title class="black--text pt--6 text-center">{{hour}}:00 - {{hour+2}}:00
        
              <v-btn v-if="`${hour}:00`==selectedDayHour" class="ml-1" color="primary" dark fab small>

        <v-icon  color="white" class="">mdi-check-bold</v-icon>
          </v-btn>
          </v-card-title>
    </v-img>
    
  </v-card>
  </v-col>
  <v-col :lg="3" v-else>
<v-card
    class="mx-auto text-center"
    max-width="500"
    min-height="80px"
    :hover="true"
    z-depth="0"
     elevation="2"
  >
   
   
      <v-card-title class="black--text pt--6 text-center">{{hour}}:00 - {{hour+2}}:00<br/><small> (obsadené)</small>
        
              <v-btn v-if="`${hour}:00`==selectedDayHour" class="ml-1" color="primary" dark fab small>

        <v-icon  color="white" class="">mdi-check-bold</v-icon>
          </v-btn>
          </v-card-title>
    </v-img>
    
  </v-card>
  </v-col>
               
</v-row>


       <!-- <v-calendar

     ref="weekcalendar"
      type="week"
      v-model="focus"
            locale="sk"
            first-interval=9
            interval-count=7
            :interval-format="intervalFormat"
            :start="selectedDay"
            :weekdays="[6]"
            >

       <template v-slot:interval="{ hour,past,date }">
            <v-sheet

                  color="primary"
                  width="100%"
                  height="100%"
                  tile
                  v-if="!past && isReservableHour(date,hour)"
                  @click="setHour(date,hour)"
                  class="timeselectable"
                >

                </v-sheet>
          </template>


    </v-calendar>-->
  </v-sheet>
  <v-spacer></v-spacer>
               </v-card>


          <div class="personaldata">
          <v-card class="" v-if="branch && selectedDayHour && !showNotAvailable">
            <v-card-title class="primary white--text" dark flat>
              <span class="headline">4. Osobné údaje</span>
            </v-card-title>
              <v-form ref="form" v-on:submit.prevent="save()" v-if="!ordersent">
            

            <v-card-text>
              <v-container grid-list-lg>

                <v-layout wrap>
                    <v-flex class="sm12 pt-3">
                        <v-icon class="pr-1">access_time</v-icon> Zvolený dátum: <strong>{{getSelectedDateHour}}</strong>
                    </v-flex>
                    <v-flex class="sm6">
                      <v-text-field v-model="name" label="Meno*" type="text"
                            prepend-icon="person"
                            :error="($v.name.$error===true)?true:false"
                            @input="setTouch('name')"
                            ></v-text-field>

                    </v-flex>
                  <v-flex class="sm6">
                  <v-text-field v-model="surname" label="Priezvisko*" type="text"
                            prepend-icon="person"
                            :error="($v.surname.$error===true)?true:false"
                            @input="setTouch('surname')"
                            ></v-text-field>
                 </v-flex>

                    <v-flex class="sm6">
                      <v-text-field v-model="email" label="E-mail*" type="text"
                            prepend-icon="mail"
                            :error="($v.email.$error===true)?true:false"
                            @input="setTouch('email')"
                            ></v-text-field>

                    </v-flex>
                  <v-flex class="sm6">
                  <v-text-field v-model="phone" label="Telefón*" type="text"
                            prepend-icon="phone"
                             :error="($v.phone.$error===true)?true:false"
                            @input="setTouch('phone')"
                            hint="+421901123456"
                            :persistent-hint="true"
                            ></v-text-field>
                 </v-flex>
                  

                    
                     
                      <v-divider></v-divider>

                    <p class="pl-2">upozornite ma na blížiaci sa termín predvádzacej jazdy prostredníctvom:</p>
                    <v-flex class="sm12">

                    <v-checkbox :error="($v.emailnotify.$error===true)?true:false" v-model="emailnotify" label="e-mailu"></v-checkbox>

                    <!--<v-checkbox :error="($v.smsnotify.$error===true)?true:false" v-model="smsnotify" label="sms"></v-checkbox>-->
                    <!--<v-flex class="sm12" v-if="emailnotify || smsnotify">
                      <v-select item-text="name"
                                  item-value="id"
                                  label="Interval upozornenia"
                                  prepend-icon="access_time"
                                  :items="getNotifyType"
                                  v-model="notify_type"
                                  :error="($v.notify_type.$error===true)?true:false"
                                  >
                      </v-select>
                    </v-flex>-->
                    </v-flex>
                      <v-flex class="sm12">
                           <p class="text-justify"> 
   Zakliknutím nižšie uvedeného políčka potvrdzujem, že som sa podrobne oboznámil 
   s Informáciami o získavaní a spracúvaní osobných údajov od dotknutej osoby podľa 
   článku 13 Všeobecného nariadenia o ochrane osobných údajov, ktoré sú dostupné <a href="https://www.audibratislava.sk/ochrana-osobnych-udajov" target="_blank">tu</a>, 
   poskytnuté osobné údaje sú pravdivé a boli poskytnuté slobodne a udeľujem súhlas spoločnosti {{ branchName }} 
   na spracovanie mojich osobných údajov v rozsahu uvedenom v bode 3 formulára za účelom:
   </p>

                    <v-checkbox :error="($v.agreement.$error===true)?true:false" v-model="agreement" label="spracovania a vybavenia rezervácie predvádzacieho vozidla*"></v-checkbox>

                    <v-checkbox :error="($v.marketing.$error===true)?true:false" v-model="marketing" label="marketingu alebo zasielania ponukových emailov / odberu noviniek"></v-checkbox>

                    <v-checkbox v-if="emailnotify || smsnotify"  :error="($v.notification.$error===true)?true:false" v-model="notification" label="upozornenia na blížiaci sa termín predvádzacej jazdy*"></v-checkbox>


                      <p class="text-justify">
a to na dobu 5 rokov od poskytnutia súhlasu.<br/>
<small>
Súhlas je možné kedykoľvek odvolať zaslaním žiadosti na emailovú adresu prevádzkovateľa <a href="mailto:info@audibratislava.sk">info@audibratislava.sk</a> 
alebo písomnej žiadosti na adresu sídla prevádzkovateľa.

</small>
  </p>
                      </v-flex>
                     <p class="red--text pl-2" v-if="submitStatus=='ERROR'">
                 Prosím vyplňte všetky povinné polia
             </p>
                </v-layout>

              </v-container>
            </v-card-text>

            <v-card-actions class="primary">
              <v-spacer></v-spacer>

              <v-btn depressed color="success" type="submit" v-if="!ordersending">{{ $vuetify.lang.t('$vuetify.save') }}</v-btn>
              <v-progress-circular
          v-if="ordersending"
      :width="3"
      color="green"
      indeterminate
    ></v-progress-circular>
            </v-card-actions>
            </v-form>
              <v-card-text v-if="ordersent===true">
                  <v-container>
              <v-layout>
                  <p>
                      Vaša rezervácia bola odoslaná, ďakujeme, na Váš e-mail bude doručený potvrdzovací e-mail.
                  <v-btn @click="newOrder" class="mt-3">Nová rezervácia</v-btn>
                  </p>
              </v-layout>
              </v-container>
    </v-card-text>
    <v-card-text v-if="ordererror!==false">
                  <v-container>
              <v-layout>
                  <p>
                      {{ordererror}}
                  <v-btn @click="newOrder" class="mt-3">Nová rezervácia</v-btn>
                  </p>
              </v-layout>
              </v-container>
    </v-card-text>
          </v-card>
          </div>


      </v-col>
      </v-row>


  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import {
  required, minLength, maxLength, email, sameAs, helpers, requiredIf
} from 'vuelidate/lib/validators';
import Vue from 'vue';
import goTo from 'vuetify/es5/services/goto';
import { default as model } from '../models/orders';

const phone = helpers.regex('alpha', /^\+[0-9]{12}$/);

export default {
  name: 'Reservation',
  mixins: [validationMixin],
  data: () => ({
    branch: 1,
    name: '',
    surname: '',
    phone: '',
    email: '',
    licence_plate: '',

    car_type: null,
    check_type: null,
    fuel_type: null,
    selectedDay: null,
    showNotAvailable: false,
    type: 'month',
    start: null,
    end: null,
    ordersending: false,
    ordererror: false,
    // today:
    today: false,
    // today:'2019-11-15',
    focus: '2019-11-15',
    ordersent: false,
    marketing: false,
    agreement: false,
    selectedDayHour: false,
    smsnotify: false,
    emailnotify: false,
    notification: false,
    notify_type: null,
    submitStatus: false,
    dateFormat: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',

    },
    editedItem: {},
  }),
  watch: {
    branch() {
      this.setHour(false, false);
      this.start = null;
      this.end = null;

      this.focus = this.today;
      if (typeof this.$refs.calendar !== 'undefined') {
        this.$refs.calendar.checkChange();
      }
    },
    smsnotify(val) {
      if(val===false && this.emailnotify===false){
        this.notification=false;
      }
    },
    emailnotify(val) {
      if(val===false && this.smsnotify===false){
        this.notification=false;
      }
    },
    
    /*check_type(value,x){
      this.setHour(false, false);
      this.start = null;
      this.end = null;
      this.focus = this.today;
      if (typeof this.$refs.calendar !== 'undefined') {
        this.$refs.calendar.checkChange();
      }
          console.log('checkt',x);
      } */
  },
  computed: {
    ...mapGetters('enums', {
      enumById: 'byId',
    }),
    ...mapGetters('calendar', {
      calendarByDay: 'byId',
    }),
    branchName() {
      const data = this.branches.find(item => item.id === this.branch);
      return data.company_name;
    },
    /* today(){
             const today = new Date();
             console.log('today',today);
console.log(today.getFullYear()+'-'+today.getMonth()+'-'+today.getDay());
             return today.getFullYear()+'-'+today.getMonth()+'-'+today.getDay();
         }, */
    branches() {
      return this.$store.getters['branches/list'];
    },
    monthData() {
      return this.$store.getters['calendar/list'];
    },
    getCarType() {
      return this.enumById('cars').enum_items;
    },
    getFuelType() {
      return this.enumById('fuel_types').enum_items;
    },
    getNotifyType() {
      return this.enumById('notification_types').enum_items;
    },
    getCheckType() {
      if (typeof this.enumById('check_types') !== 'undefined') {
        return this.enumById('check_types').enum_items;
      }

      return [];
    },
    getCheckTypeById(id) {
      let checkTypes = this.getCheckType();
   
    },
    getSelectedDateHour() {
      if (this.selectedDay && this.selectedDayHour) {
        const day = this.selectedDay.split('-')[2];
        const month = this.selectedDay.split('-')[1];
        const year = this.selectedDay.split('-')[0];

        return `${day}.${month}.${year} ${this.selectedDayHour}`;
        // console.log('SELECTEDH',this.selectedDay,this.selectedDayHour);
        //  new Intl.DateTimeFormat('sk-SK', { month: 'long'}).format(this.selectedDay);
      }
    },
    title() {
      const { start, end } = this;
      if (!start || !end) {
        const dte = new Date();
        return `${new Intl.DateTimeFormat('sk-SK', { month: 'long' }).format(dte)} ${dte.getFullYear()}`;
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? '' : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? '' : endYear;

      const startDay = start.day;
      const endDay = end.day;

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`;
        case 'week':
        case '4day':
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return '';
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long', locale: 'sk',
      });
    },
  },
  created() {
    this.initialize();

    // this.setFilterValues();
  },
  validations() {
    const validation = {};
    validation.name = { required, maxLength: maxLength(255) };
    validation.surname = { required, maxLength: maxLength(255) };
    validation.email = { required, maxLength: maxLength(255), email };
    validation.phone = { required, phone, maxLength: maxLength(13) };
    // validation.licence_plate = { required, maxLength: maxLength(7) };
    // validation.car_type = { required, maxLength: maxLength(7) };
    validation.check_type = { required, maxLength: maxLength(7) };
    // validation.fuel_type = { required, maxLength: maxLength(7) };
    validation.agreement = { sameAs: sameAs(() => true) };
    validation.emailnotify = { };
    // validation.smsnotify = { };
    validation.notification = { sameAs: sameAs(function(value) {
      if (this.emailnotify || this.smsnotify){
        return true;
      }else{
        return false;
      }
    }) };
    validation.marketing = { };
    /* validation.notify_type = {required: requiredIf(function () {
        return this.emailnotify || this.smsnotify
      }) }; */
    return validation;
  },
  methods: {
    reInitCal(){
      $this.$refs.calendar.change();
    },
    setCheckType(x) {
      this.showNotAvailable = false;
      const checkt = this.getCheckType;
      for (const check in checkt) {
        if (checkt[check].id === x) {
          if (checkt[check].disallowed === true) {
            this.check_type = x;
            this.showNotAvailable = true;
          } else {
            this.check_type = x;
          }
        }
      }
      this.initCalendarMonth(this.start, this.end);
      goTo('.dateselect');
    },
    niceDateFormat(date) {
      let day = date.split('-')[2];
      if (day < 10) {
        day = day.replace('0', '');
      }
      const month = date.split('-')[1];

      return `${day}.${month}`;
    },
    newOrder() {
      this.setHour(false, false);
      this.ordersent = false;
      this.branch = 1;
      this.ordererror = false;
      this.initCalendarMonth();
    },
    setTouch(element) {
      this.$v[element].$touch();
    },
    getCalendarDay(date) {
      //   console.log(date);
      return this.calendarByDay(date);
    },
    setTodayDate() {
      const today = new Date();

      this.today = `${today.getFullYear()}-${today.getUTCMonth() + 1}-${today.getDate()}`;
    },
    canBeSet() {
      return true;
    },
    isWeekend(day) {
      return day === 0 || day === 6;
    },
    isReservable(date) {
      // console.log('date',date);
      // console.log('apidate',this.getCalendarDay(date));
      const day = this.getCalendarDay(date);
      if (typeof day !== 'undefined' && day.enums) {
        if (day.enums['h'+this.check_type] > 0) {
          return true;
        }

        return false;
      }

      return false;
    },
    isReservableHour(date, hour) {
      // console.log('datehour',date);
      //console.log(this.check_type);
      //  console.log('apidate',this.getCalendarDay(date));
      const day = this.getCalendarDay(date);
      if (typeof day !== 'undefined') {
        if (day.available > 0) {
          if (typeof day.hours[`h${this.check_type}${hour}`] !== 'undefined' && day.hours[`h${this.check_type}${hour}`] > 0) return true;

          return false;
        }

        return false;
      }

      return false;
    },
    intervalFormat(interval) {
      const longOptions = {
        timeZone: 'UTC', hour12: true, hour: '2-digit', minute: '2-digit',
      };
      const shortOptions = {
        timeZone: 'UTC', hour12: true, hour: 'numeric', minute: '2-digit',
      };
      const shortHourOptions = { timeZone: 'UTC', hour12: true, hour: 'numeric' };

      return interval.time;
    },
    initialize() {
      this.$store.dispatch('branches/fetchList');
      this.$store.dispatch('enums/fetchList');
    },
    initCalendarMonth(start, end) {
      //  console.log('branc',start);
      const filters = [{
        field: 'branch',
        value: this.branch,
      }];
      if (start && typeof start !== 'undefined' && start !== 1) {
        filters.push({
          field: 'start',
          value: start.date,
        });
      }
      if (end && typeof end !== 'undefined') {
        filters.push({
          field: 'end',
          value: end.date,
        });
      }
      this.$store.dispatch('calendar/fetchList', {
        customUrlFnArgs: {

          filters,

        },
      });
      // console.log('monthdata',this.monthData);
    },
    setDay(date) {
      this.setDayInternal(date);
      goTo('.timeselect');
    },
    setDayInternal(date) {
      this.selectedDay = date;
      this.focus = date;
      //  goTo("#time");
    },
    setHour(date, hour) {
      const day = this.getCalendarDay(date);
      if (day !== false && typeof day !== 'undefined' && typeof day.first_order !== 'undefined') {
        const firstHour = day.first_order.split(':')[0];
        if (parseInt(hour) === parseInt(firstHour)) {
          this.setHourInternal(date, day.first_order);
        } else {
          this.setHourInternal(date, (hour !== false) ? `${hour}:00` : hour);
        }
      } else {
        this.setHourInternal(date, (hour !== false) ? `${hour}:00` : hour);
      }
      goTo('.personaldata');
    },
    setHourInternal(date, hour) {
      this.setDayInternal(date);
      this.selectedDayHour = hour;
      //  goTo("#time");
    },
    prev() {
      this.setHourInternal(false, false);
      this.$refs.calendar.prev();
    },
    next() {
      this.setHourInternal(false, false);
      this.$refs.calendar.next();
    },
    prevWeek() {
      //   this.setHourInternal(false,false);
      this.$refs.weekcalendar.prev();
    },
    nextWeek() {
      //  this.setHourInternal(false,false);
      this.$refs.weekcalendar.next();
    },
    setToday() {
      this.focus = this.today;
    },
    updateRange({ start, end }) {
      //  console.log(start);
      // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
      this.start = start;
      this.end = end;
      this.initCalendarMonth(start, end);
    },

    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
      } else {
        this.ordersending = true;
        this.doCreate();
      }
    },

    /**
         * Method creates entity in store (usually also in API)
         * @returns {none}
         */
    doCreate() {
      const formData = new FormData();


      formData.append('name', this.name);
      formData.append('surname', this.surname);
      formData.append('email', this.email);
      formData.append('phone', this.phone);
      // formData.append('car_type', this.car_type);
      formData.append('check_type', this.check_type);
      // formData.append('fuel_type', this.fuel_type);
      formData.append('branches_id', this.branch);
      // formData.append('licence_plate', this.licence_plate);
      formData.append('agreement', this.agreement);
      formData.append('marketing', this.marketing);
      formData.append('notification', this.notification);
      // formData.append('smsnotify', this.smsnotify);
      formData.append('emailnotify', this.emailnotify);
      // formData.append('notify_type', this.notify_type);
      formData.append('selectedDay', this.selectedDay);
      formData.append('selectedDayHour', this.selectedDayHour);
      const that = this;
      this.$store.dispatch('orders/create', {
        data: formData,
      }).then((data) => {
        that.ordersending = true;
        that.ordersent = true;
        that.ordererror = false;
      
      }).catch((err)=>{

        that.ordersent = false;
        that.ordersending = false;
        that.ordererror = err.response.data.data.error;
      }).finally(() => {
        
        that.ordersending = false;
        /*that.$gtm.trackView('Order', 'currentpath');
        Vue.analytics.fbq.event('ViewContent', {
          content_name: 'Order',
        });
        that.$gtag.event('order');*/
      });
    },
  },
  mounted() {
    this.setTodayDate();
    this.focus = this.today;
    // this.$refs.calendar.checkChange();
  },


};
</script>
<style>
    .timeselectable{
                cursor: pointer;
    }
    .v-outside{

    }
    .v-calendar-weekly__head-weekday{
          padding: .5rem 0!important;
    font-weight: bold!important;
    color: black!important;
    }
    </style>
